import { FormField, GenericFieldType } from '../types/ContactForm';

export const resolveGenericFieldValue = (
    genericType: GenericFieldType | undefined,
    genericFieldValues?: Partial<Record<GenericFieldType, string>>
): string => {
    if (!genericType) {
        return '';
    }
    if (genericType === 'shop-url') {
        return genericFieldValues?.['shop-url'] || window.location.href;
    }
    return genericFieldValues?.[genericType] ?? '';
};

export const isFieldRenderable = (
    field: FormField,
    genericFieldValues?: Partial<Record<GenericFieldType, string>>
): boolean => {
    if (field.type !== 'generic') {
        return true;
    }
    return resolveGenericFieldValue(field.genericType, genericFieldValues) !== '';
};
